import { createFileRoute } from "@tanstack/react-router";
import { AboutUs } from "@/pages/information/about-us";

export const Route = createFileRoute("/about-us")({
  component: AboutUs,
});
